import React, {Component} from "react";
import ValueType from "./ValueTypeView";
import {ValueTypeService} from "../../../service/maintenance/valueType/ValueTypeService";
import {Builder} from "../../../utils/lists/ListProcessor";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {CREATE_EDIT_GROUP_ROUTE} from "../../../utils/constants/RoutesConstants";
import ContextMenu from "../../../components/contextMenu";
import {Growl} from "primereact/growl";

export default class ValueTypeContainer extends Component {
    constructor(props) {
        super(props);

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.valueTypeService = new ValueTypeService();

        this.loading = this.loading.bind(this);
        this.getValueTypes = this.getValueTypes.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.valueTypeTemplate = this.valueTypeTemplate.bind(this);
        this.groupTemplate = this.groupTemplate.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.editLabelValueType = this.editLabelValueType.bind(this);
        this.onChangeTextDialog = this.onChangeTextDialog.bind(this);
        this.deleteGroup = this.deleteGroup.bind(this);
        this.selectRowControlPanel = this.selectRowControlPanel.bind(this);
        this.addGroup = this.addGroup.bind(this);
        this.updateGroup = this.updateGroup.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);

        this.state = {
            isLoading: true,
            valueTypeList: [],
            displayDialog: false,
            valueTypeSelected: '',
            options: [],
            selectedGroup: '',
            expanded: true,
        };

        this.getValueTypes();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    getValueTypes() {
        this.loading(true);
        this.valueTypeService.getValueTypes().then(
            response => {
                response.payload.forEach(function (v) {
                    v.groupId = v.grupo.id;
                    v.groupName = v.grupo.nombre;
                    delete v.grupo;
                });
                let builder = new Builder();
                builder.groupList(response.payload, 'groupName');

                this.setState({
                    valueTypeList: builder.mapObjects,
                    expandedRows: builder.mapObjects,
                });
                this.loading(false);
            });
    }

    handleToggle = (event) => {
        this.setState(
            {
                expandedRows: event.data,
            })
    };

    showDialog(rowData) {
        this.setState({
            displayDialog: true,
            valueTypeSelected: rowData,
        });
    }


    valueTypeTemplate(rowData) {
        let dataSelected = JSON.parse(JSON.stringify(rowData));
        return <Button type="button" label="Editar" style={{marginRight: '3em'}}
                       onClick={() => this.showDialog(dataSelected)}
        />;
    }

    rowExpansionTemplate(data) {
        const itemsInstitution = data.items;
        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    value={itemsInstitution}
                    responsive={true}
                    selectionMode="single">
                    <Column field="nombre" header="Nombre" style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="descripcion" header="Descripción" style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="etiqueta" header="Etiqueta" style={{textAlign: 'left'}} sortable={true}/>
                    <Column header="Acciones"
                            body={this.valueTypeTemplate}
                            style={{textAlign: 'center', width: '8em'}}/>
                </DataTable>
            </div>
        );
    }

    onHideDialog() {
        this.setState({
            displayDialog: false
        });
    }

    getDialogHeader() {
        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Editar Valor</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Cancelar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.editLabelValueType}/>
                </div>
            </div>
        );
    }

    editLabelValueType() {
        this.loading(true);
        this.valueTypeService.editLabelValueType(this.state.valueTypeSelected.id, this.state.valueTypeSelected.etiqueta)
            .then(resp => {
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: resp.error
                    });
                }else{
                    this.growl.show({
                        severity: 'success', summary: 'Atención.',
                        detail: 'La información se actualizó correctamente.'
                    });
                }
            this.setState({
                displayDialog: false,
            });
            this.loading(false);
            this.getValueTypes();
        });
    }

    onChangeTextDialog(event) {
        const {name, value} = event.target;
        let valueType = this.state.valueTypeSelected;
        valueType[name] = value;
        this.setState({valueTypeSelected: valueType,})
    }

    handleMenuItemClick(option) {
        if (option === 'Eliminar') {
            if (this.state.selectedGroup) {
                this.setState({
                    groupIdDelete: this.state.selectedGroup.items[0].groupId,
                });
                if (this.confirmationRef) {
                    this.confirmationRef.openConfirmationMessage()
                }
            }
        } else {
            if (option === 'Modificar') {
                this.updateGroup();
            }
        }
    }

    groupTemplate(rowData) {
        let optionsMenu = [
            {label: "Editar Grupo", action: ()=>{this.handleMenuItemClick("Modificar")}},
            {label: "Eliminar Grupo", action: ()=>{this.handleMenuItemClick("Eliminar")}},
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    deleteGroup() {
        this.loading(true);
        this.valueTypeService.deleteGroup(this.state.groupIdDelete)
            .then(res => {
                if (res.error && res.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.error
                    });
                }else{
                    this.growl.show({
                        severity: 'sucess', summary: 'Éxito.',
                        detail: (res.message === 'Success' || res.message === '')?
                            'El grupo se ha eliminado' : res.message
                    });
                }
                this.loading(false);
                this.getValueTypes();
            });
    }

    selectRowControlPanel(event) {
        this.setState({
            selectedGroup: event.value,
        });
    }

    addGroup() {
        this.props.history.push({
            pathname: CREATE_EDIT_GROUP_ROUTE,
            state: {},
        });
    }

    updateGroup() {
        this.props.history.push({
            pathname: CREATE_EDIT_GROUP_ROUTE,
            state: {
                group: this.state.selectedGroup.items[0],
            },
        });
    }

    /**
     * Función que se encarga de contraer y expandir los grupos
     */
    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.valueTypeList,
                expanded: true,
            });
        }
    }

    render() {
        this.deleteGroupConfMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                                       invisible={true}
                                                       legend="¿Desea borrar el grupo?"
                                                       action={this.deleteGroup}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <ValueType
            isLoading={this.state.isLoading}
            getValueTypes={this.getValueTypes}
            valueTypeList={this.state.valueTypeList}
            expandedRows={this.state.expandedRows}
            handleToggle={this.handleToggle}
            rowExpansionTemplate={this.rowExpansionTemplate}
            displayDialog={this.state.displayDialog}
            onHideDialog={this.onHideDialog}
            dialogHeader={this.getDialogHeader()}
            valueTypeSelected={this.state.valueTypeSelected}
            onChangeTextDialog={this.onChangeTextDialog}
            groupTemplate={this.groupTemplate}
            deleteGroupConfMsg={this.deleteGroupConfMsg}
            selectedGroup={this.state.selectedGroup}
            selectRowControlPanel={this.selectRowControlPanel}
            addGroup={this.addGroup}
            expandReduceAll={this.expandReduceAll}
            messagesGrowl={messagesGrowl}
        />
    }
}